export default {
  getOrder: { method: 'post', url: '/api/v1/pgt/getOrder' }, // LP理财获取订单
  list: { method: 'get', url: '/api/v1/pgt/list' }, // LP理财订单列表
  redemption: { method: 'post', url: '/api/v1/pgt/redemption' }, // LP理财赎回
  reinvest: { method: 'post', url: '/api/v1/pgt/reinvest' } // LP理财立即复投
}
